import {
  Component,
  Inject,
  Input,
  OnInit,
  forwardRef
} from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { Table }           from '../table/types/table';
import { TableQueryModel } from '../../app-customer/table/models/table-query';
import { VendorModel }     from './models/vendor';

@Component({
  selector   : 'wor-vendor-activity-logs',
  template: require('./vendor.activity-logs.component.html')
})
export class VendorActivityLogsComponent implements OnInit {
  @Input() vendor : VendorModel;

  logs : Array<any>;

  tableSettings : Table = {
    columns: [
      {
        field : 'created_by',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.SOURCE')
        }
      },
      {
        classes: 'all-caps',
        field  : 'activity_type',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TYPE')
        }
      },
      {
        field : 'date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'dateTime'
      },
      {
        field : 'activity',
        header: {
          text: this.translateService.instant('INVOICE_SPACE.ACTIVITY')
        }
      },
      {
        field : 'user',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.USERS.USER')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ACTIVITY_LOGS'),
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => this.apiService.get('/vendor_activity_log_count', this.vendor.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService      : ApiService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.getLogs({
      pageSize: this.tableSettings.pagination.pageSize,
      offset  : 0
    } as TableQueryModel);
  }

  getLogs ( params : TableQueryModel ) : ng.IPromise<Array<any>> {
    return this.apiService.get('/vendor_activity_logs', [
        this.vendor.id,
        params.pageSize,
        params.offset
      ])
      .then((logs : Array<any>) => {
        this.logs = logs;

        return logs;
      });
  }
}
